import { Link } from "react-router-dom";
import "./vim.scss";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import Footer from "../../../../../components/Footer/Footer";

export default function VimshottariLinks() {
  const links = [
    { label: "Vimshottari MD & AD", path: "/jyotish/janma-kundali/main-page/vimshottari-md-ad" },
    { label: "Vimshottari AD & PD # 1", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-1" },
    { label: "Vimshottari AD & PD # 2", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-2" },
    { label: "Vimshottari AD & PD # 3", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-3" },
    { label: "Vimshottari AD & PD # 4", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-4" },
    { label: "Vimshottari AD & PD # 5", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-5" },
  ];

  const sdLinks = [
    { label: "Vimshottari AD & PD & SD # 1", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-sd-1" },
    { label: "Vimshottari AD & PD & SD # 2", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-sd-2" },
    { label: "Vimshottari AD & PD & SD # 3", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-sd-3" },
    { label: "Vimshottari AD & PD & SD # 4", path: "/jyotish/janma-kundali/main-page/vimshottari-ad-pd-sd-4" },
  ];

  return (
    <div className="vimshottari-container">
        <InnerNav/>
      <h1 className="vimshottari-title">Vimshottari Links</h1>
      <div className="vimshottari-flex">
        {/* Left side links */}
        <ul className="vimshottari-list left">
          {links.map((item, index) => (
            <li key={index} className="vimshottari-item">
              <Link to={item.path} className="vimshottari-link">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Right side links */}
        <ul className="vimshottari-list right">
          {sdLinks.map((item, index) => (
            <li key={index} className="vimshottari-item">
              <Link to={item.path} className="vimshottari-link">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Footer/>
    </div>
  );
}
